"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchMeetingsUser = fetchMeetingsUser;
exports.fetchPublicAvailabilityInfo = fetchPublicAvailabilityInfo;
exports.fetchCompanyName = fetchCompanyName;
exports.createMeeting = createMeeting;

var _endpoints = require("MeetingsLib/constants/endpoints");

function fetchMeetingsUser(httpClient, slug, includeInactiveLink) {
  return httpClient.get(_endpoints.PUBLIC_BOOK_ENDPOINT + "/user", {
    query: {
      includeInactiveLink: includeInactiveLink,
      slug: slug
    },
    withCredentials: false
  });
}

function fetchPublicAvailabilityInfo(httpClient, queryParams) {
  return httpClient.get("" + _endpoints.PUBLIC_BOOK_ENDPOINT, {
    withCredentials: false,
    query: queryParams,
    timeout: 12000
  });
}

function fetchCompanyName(httpClient, slug) {
  return httpClient.get(_endpoints.LINK_ENDPOINT + "/" + slug + "/company", {
    withCredentials: false
  });
}

function createMeeting(httpClient, queryParams, data) {
  return httpClient.post("" + _endpoints.PUBLIC_BOOK_ENDPOINT, {
    withCredentials: false,
    query: queryParams,
    timeout: 30000,
    data: data
  });
}